// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"668":"a080622314456078262c","935":"740bf3d9812d1177adbf"}[chunkId] + ".css";
};